// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"list__list--26xYA","inline":"list__inline--1qmWn","item":"list__item--3TKec"};